'use client';

import type { SearchHeaderProps } from './types';
import { CloseIcon } from './icons';

export default function SearchHeader({ onClose }: SearchHeaderProps) {
  return (
    <div className="flex items-center justify-between self-stretch pt-9 px-6">
      <h2 className="text-[22px] font-medium font-gotham text-text-primary leading-[28px] pl-[10px]">
        Τι ψάχνετε σήμερα;
      </h2>
      <button
        onClick={onClose}
        className="w-9 h-9 flex items-center justify-center text-text-secondary hover:text-text-primary transition-colors"
        aria-label="Close search"
      >
        <CloseIcon className="w-5 h-5" />
      </button>
    </div>
  );
}
